<script lang="ts">
import { AppVehicleOptionsComponent } from "./app-vehicle-options";
export default AppVehicleOptionsComponent;
</script>

<template>
    <div
        id="feature-wrapper"
        class="features__list-label tooltip__info"
        data-wow-delay=".15s"
        v-if="isNotEmpty()"
        :class="{
            label__spec: showLabel,
            'wow fadeIn': !disableWowEffect,
            tooltip__info: !showLabel,
            'label__spec--without-icon': !option.icon_href,
        }"
        v-for="(option, index) in options"
        :key="index"
        v-tippy="!showLabel && { content: option.name, interactive: true }"
        :style="{
            border: option.icon_href && !showLabel ? 'none' : undefined,
            padding: !showLabel ? 'unset' : undefined,
        }"
    >
        <img
            id="feature-img"
            v-if="option.icon_href"
            :src="option.icon_href"
            class="sprite-icon features__list-icon label__spec-icon"
            alt=""
        />
        <p v-if="showLabel" class="label__spec-name">
            {{ option.name }}
        </p>
    </div>
    <div data-wow-delay=".15s" v-else>
        <p class="list-item">
            <i18n-t keypath="carDetails.mainFeaturesAreNotAvailable" />
        </p>
    </div>
</template>
<style lang="scss">
@import "../../../shared/styles/mixins";
.features__list-icon--38 {
    width: c-rem(38);
    height: c-rem(38);
}
@media only screen and (max-width: 768px) {
    #feature-wrapper {
        padding: 0.6rem c-rem(10) 0.6rem c-rem(10);
        display: flex;
        gap: c-rem(10);
    }
    #feature-img {
        position: unset;
        left: unset;
        top: unset;
    }
    .features__list-label {
        min-width: unset;
    }
}
</style>
